/* eslint-disable immutable/no-mutation */
import isMoreThanOneWeekOld from './isMoreThanOneWeekOld';

class NotificationQueue {
  queue: WorkerNotification[] = [];
  timer?: NodeJS.Timer;
  lastMessageSentTime: number = Date.now();

  constructor() {
    setInterval(() => {
      if (Date.now() - this.lastMessageSentTime > 15000) {
        this.sendMessage();
      }
    }, 15000);
  }

  addToQueue(notification: WorkerNotification) {
    const id = notification.data.id;
    if (id && this.queue.some((n) => n.data.id === id)) {
      return;
    }
    if (isMoreThanOneWeekOld(notification.data)) {
      return;
    }
    this.queue.push(notification);
    if (this.queue.length === 1) {
      this.sendMessage();
    }
  }

  sendMessage() {
    if (this.queue.length > 0) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.queue.sort(compareNotifications);
        postMessage(this.queue.shift());
        this.lastMessageSentTime = Date.now();
      }, 2000);
    }
  }
}

const compareNotifications = (a: WorkerNotification, b: WorkerNotification) =>
  PriorityMap[a.priority] - PriorityMap[b.priority];

const PriorityMap: Record<Priority, number> = { high: 0, normal: 1, low: 2 };

export default NotificationQueue;
